import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function WhoIsItFor() {
  const { elementRef: headerRef } = useScrollAnimation();
  const { elementRef: ref0 } = useScrollAnimation({ delay: 0 });
  const { elementRef: ref1 } = useScrollAnimation({ delay: 100 });
  const { elementRef: ref2 } = useScrollAnimation({ delay: 200 });

  const cardRefs = [ref0, ref1, ref2];

  const profiles = [
    {
      icon: 'ri-briefcase-line',
      title: 'The Busy Professional',
      description: 'You have a demanding career, but you refuse to let your health slip. You need a program that fits your schedule — not the other way around.',
    },
    {
      icon: 'ri-parent-line',
      title: 'The Dedicated Parent',
      description: 'You want to be strong, energized, and present for your family. You know that taking care of yourself is not selfish — it is necessary.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'The High Performer',
      description: 'You are already winning in life, but you know your body is the foundation for everything else. You are ready to level up physically and mentally.',
    },
  ];

  return (
    <section className="py-20 sm:py-28" style={{ background: '#fafafa' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div ref={headerRef} className="animate-fade-up text-center mb-16">
          <p className="text-xs font-bold tracking-[0.35em] uppercase mb-3" style={{ color: '#B8860B' }}>
            Who This Is For
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-5 leading-tight text-gray-900">
            I Only Work With People Who Are Serious
          </h2>
          <p className="text-sm sm:text-base max-w-2xl mx-auto" style={{ color: '#666666' }}>
            This is not for everyone. If you are looking for quick fixes or magic pills, this is not the place. But if you are ready to commit, here is who thrives in this program:
          </p>
          <div className="w-16 h-1 mx-auto rounded-full mt-6" style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)' }} />
        </div>

        {/* Profile Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {profiles.map((profile, idx) => (
            <div
              key={idx}
              ref={cardRefs[idx]}
              className="animate-fade-up bg-white rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1"
              style={{
                border: '1px solid #ebebeb',
                boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
              }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-xl mb-5"
                style={{ background: '#B8860B18', border: '1px solid #B8860B33' }}
              >
                <i className={`${profile.icon} text-2xl`} style={{ color: '#B8860B' }}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">{profile.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: '#666666' }}>
                {profile.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <div
            className="inline-block rounded-xl px-6 py-3 mb-6"
            style={{ background: '#C8102E0f', border: '1px solid #C8102E33' }}
          >
            <p className="text-sm font-bold" style={{ color: '#C8102E' }}>
              <i className="ri-alarm-warning-line mr-2"></i>
              LIMITED AVAILABILITY — Only 5 spots open this month for new clients
            </p>
          </div>
          <p className="text-base font-medium max-w-2xl mx-auto" style={{ color: '#555555' }}>
            If this sounds like you, let&apos;s talk. But know this: I am selective about who I work with. You need to be ready to commit.
          </p>
        </div>

      </div>
    </section>
  );
}
